/**
 * Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 * All information herein, source code below as well as the Morpheus system itself and all related
 * software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 * Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 * is prohibited.
 */

import { replaceSubdomain } from '@morpheus/utils/admin-vue/helpers/api-helper'
import axios from 'axios'
import {
  EntitlementCreateData,
  EntitlementShowData,
  EntitlementsListData,
  InventoryAddData, InventoryEditData,
  InventoryShowData,
  EntitlementTypeData
} from '../types'

const inventoryBaseURL = replaceSubdomain(process.env.VUE_APP_API_SUBDOMAIN_INVENTORY)

export const inventoryClient = axios.create({
  baseURL: inventoryBaseURL
})

export function fetchEntitlementsList (param: string): Promise<EntitlementsListData> {
  param = param || ''
  return new Promise((resolve, reject) => {
    inventoryClient.get(`/entitlements${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchEntitlementById (id: string): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.get(`/entitlements/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function createEntitlement (entitlement: EntitlementCreateData): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.post('/entitlements', entitlement)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updateEntitlement (entitlement: EntitlementCreateData, id: string): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.put(`/entitlements/${id}`, entitlement)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function deleteEntitlementById (id: string): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.delete(`/entitlements/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchInventoryListByUserId (userId: string, param: string): Promise<EntitlementsListData> {
  return new Promise((resolve, reject) => {
    inventoryClient.get(`/user/${userId}${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function addInventoryToUser (userId: string, entitlementId: string, inventoryData: InventoryAddData): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.post(`/user/${userId}/${entitlementId}`, inventoryData)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchInventoryItemById (id: string): Promise<InventoryShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.get(`/item/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function updateInventoryItem (inventory: InventoryEditData, id: string): Promise<InventoryShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.put(`/item/${id}`, inventory)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function deleteInventoryItemById (id: string): Promise<EntitlementShowData> {
  return new Promise((resolve, reject) => {
    inventoryClient.delete(`/item/${id}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export function fetchEntitlementTypesList (param: string): Promise<Array<EntitlementTypeData>> {
  param = param || ''
  return new Promise((resolve, reject) => {
    inventoryClient.get(`/item-types/${param}`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error.response.data)
      })
  })
}

export default {
  fetchEntitlementsList,
  fetchEntitlementById,
  createEntitlement,
  updateEntitlement,
  deleteEntitlementById,
  fetchInventoryListByUserId,
  addInventoryToUser,
  fetchInventoryItemById,
  updateInventoryItem,
  deleteInventoryItemById,
  fetchEntitlementTypesList
}
